/* kott-hero-slideshow
 *
 * Drives the bento hero. Desktop and mobile are two separate sliders in the
 * DOM (the slide grouping differs: a grid of panels vs. one panel per slide),
 * so only the one that is currently visible gets a Flickity instance -- the
 * hidden one has no width and would initialise wrong.
 *
 * Reuses theme.Slideshow, which already handles RTL, autoplay, the pause
 * button and resize.
 */
(function () {
  var BREAKPOINT = '(min-width: 769px)';
  var SECTION_TYPE = 'kott-hero-slideshow';

  function KottHeroSlideshow(container) {
    this.container = container;
    this.id = container.getAttribute('data-section-id');
    this.desktopEl = container.querySelector('#KottHero-' + this.id);
    this.mobileEl = container.querySelector('#KottHeroMobile-' + this.id);
    this.mql = window.matchMedia(BREAKPOINT);
    this.slider = null;
    this.activeEl = null;
    this.initialIndex = 0;

    this.onBreakpointChange = this.setup.bind(this);
    if (this.mql.addEventListener) {
      this.mql.addEventListener('change', this.onBreakpointChange);
    } else {
      this.mql.addListener(this.onBreakpointChange);
    }

    this.setup();
  }

  KottHeroSlideshow.prototype = Object.assign({}, KottHeroSlideshow.prototype, {
    currentEl: function () {
      return this.mql.matches ? this.desktopEl : this.mobileEl;
    },

    setup: function () {
      var el = this.currentEl();
      if (!el || (this.activeEl === el && this.slider)) return;

      this.destroySlider();
      this.activeEl = el;
      el.classList.add('loaded');

      var slides = el.querySelectorAll('.slideshow__slide');
      if (slides.length < 2) {
        if (slides[0]) slides[0].classList.add('is-selected');
        return;
      }

      this.slider = new theme.Slideshow(el, {
        fade: false,
        adaptiveHeight: false,
        setGallerySize: true,
        wrapAround: true,
        prevNextButtons: el.hasAttribute('data-arrows'),
        pageDots: false,
        initialIndex: this.initialIndex,
        autoPlay:
          el.dataset.autoplay === 'true' ? parseInt(el.dataset.speed, 10) : false
      });

      // Panel heights come from container-query units, which do not resolve
      // until the wrapper has been laid out. Flickity sizes its viewport from
      // the cell heights it measures at init, so on the first paint -- and on
      // a breakpoint switch, where this element goes from display:none to
      // visible -- it can latch onto a height of 0. Re-measure once layout
      // has settled, and again when the artwork lands.
      this.nudge();
    },

    nudge: function () {
      var self = this;

      requestAnimationFrame(function () {
        self.resizeSlider();
        requestAnimationFrame(function () {
          self.resizeSlider();
        });
      });

      if (!this.activeEl) return;
      var imgs = [].slice.call(this.activeEl.querySelectorAll('img'));
      imgs.forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          self.resizeSlider();
        }, { once: true });
      });
    },

    resizeSlider: function () {
      if (this.slider && typeof this.slider.resize === 'function') {
        this.slider.resize();
      }
    },

    destroySlider: function () {
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy();
      }
      this.slider = null;
      this.activeEl = null;
    },

    forceReload: function () {
      this.destroySlider();
      this.setup();
    },

    onUnload: function () {
      this.destroySlider();
      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onBreakpointChange);
      } else {
        this.mql.removeListener(this.onBreakpointChange);
      }
    },

    onDeselect: function () {
      if (this.slider && typeof this.slider.play === 'function') {
        this.slider.play();
      }
    },

    // Theme editor: jump to whichever slide holds the block being edited.
    onBlockSelect: function (evt) {
      if (!this.activeEl) return;

      var panel = this.activeEl.querySelector(
        '[data-block-id="' + evt.detail.blockId + '"]'
      );
      if (!panel) return;

      var slide = panel.closest('.slideshow__slide');
      if (!slide) return;

      var index = parseInt(slide.dataset.index, 10) || 0;

      if (this.slider && typeof this.slider.pause === 'function') {
        this.slider.goToSlide(index);
        this.slider.pause();
      } else {
        this.initialIndex = index;
      }
    },

    onBlockDeselect: function () {
      if (this.slider && typeof this.slider.play === 'function') {
        if (this.slider.args && this.slider.args.autoPlay) {
          this.slider.play();
        }
      }
    }
  });

  function register() {
    if (!window.theme || !theme.sections || !theme.Slideshow) return false;
    theme.sections.register(SECTION_TYPE, KottHeroSlideshow);
    return true;
  }

  // theme.js sets up theme.sections on load; this file may parse before that.
  if (!register()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!register()) {
        window.addEventListener('load', register);
      }
    });
  }
})();
